import React, { CSSProperties, FC } from 'react';
import './index.less';

interface IBaseLayout {
  width?: number;
  style?: CSSProperties | undefined;
}
const BaseLayout: FC<IBaseLayout> = (props) => {
  const { width = 1200, style } = props;

  return (
    <div style={{ ...style, width }} className="base-layout">
      {props.children}
    </div>
  );
};

export default BaseLayout;
